import ng from 'angular';

export class MoleculeButtonRenewController implements ng.IController {
    public static $inject: string[] = [];

    public renew: () => void;
    public modifier = '';
    public disabled = false;
}

export class MoleculeButtonRenewComponent implements ng.IComponentOptions {
    public transclude = true;
    public bindings = {
        disabled: '<',
        modifier: '@?',
        renew: '<',
    };
    public controller =  MoleculeButtonRenewController;
    public template = require('./button-renew.html');
}
